import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=3580c210"
import script from "./edit-user.vue?vue&type=script&lang=js"
export * from "./edit-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports